// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SleepComponent} from './Sleep.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSleep = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SleepComponent/>
  </Icon>
));
